import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { OpeningHook } from './components/sections/OpeningHook';
import { ProblemSection } from './components/sections/ProblemSection';
import { FailedApproaches } from './components/sections/FailedApproaches';
import { ResetMethod } from './components/sections/ResetMethod';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { WhoIsFor } from './components/sections/WhoIsFor';
import { HowItWorks } from './components/sections/HowItWorks';
import { ProofSection } from './components/sections/ProofSection';
import { FaqSection } from './components/sections/FaqSection';
import { OfferSection } from './components/sections/OfferSection';
import { Footer } from './components/sections/Footer';
import { SectionDivider } from './components/ui/SectionDivider';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark-900 text-offwhite font-sans selection:bg-gold selection:text-dark-900 overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SectionDivider data-id="element-2" />

      <OpeningHook data-id="element-3" />
      <SectionDivider data-id="element-4" />

      <ProblemSection data-id="element-5" />

      <FailedApproaches data-id="element-6" />
      <SectionDivider data-id="element-7" />

      <ResetMethod data-id="element-8" />
      <SectionDivider data-id="element-9" />

      <WhatYouGet data-id="element-10" />

      <WhoIsFor data-id="element-11" />
      <SectionDivider data-id="element-12" />

      <HowItWorks data-id="element-13" />

      <ProofSection data-id="element-14" />
      <SectionDivider data-id="element-15" />

      <FaqSection data-id="element-16" />

      <OfferSection data-id="element-17" />

      <Footer data-id="element-18" />
    </div>;
}